import { render, staticRenderFns } from "./m_m_payee_list.vue?vue&type=template&id=88703798&scoped=true"
import script from "./m_m_payee_list.vue?vue&type=script&lang=js"
export * from "./m_m_payee_list.vue?vue&type=script&lang=js"
import style0 from "./m_m_payee_list.vue?vue&type=style&index=0&id=88703798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88703798",
  null
  
)

export default component.exports